
import { Component, Prop, Vue } from "vue-property-decorator";
import axios from "axios";
import router from "@/router";
import { cacheSrv } from "./../services/cache";
import store from "./../store";
import { systemSrv } from '@/services/system';
import HeaderRewards from './../components/common/HeaderRewards.vue'

@Component({
  components: {HeaderRewards}
})
export default class ResetPassword extends Vue {
  strongRegex = new RegExp(
    "^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})"
  );
  mediumRegex = new RegExp(
    "^(((?=.*[a-z])(?=.*[A-Z]))|((?=.*[a-z])(?=.*[0-9]))|((?=.*[A-Z])(?=.*[0-9])))(?=.{6,})"
  );
  passwordStrength = { "background-color": "red" };
  mismatchPass = false

  emailFormSubmitted = false;
  authAPIUrl = this.$store.getters.config.authAPIUrl;
  user:any = {
    password: "",
    repeat_password: "",
    meta:""
  };
  submitted = false;
  processing = false;
  errorMessage = "";
  
  constructor() {
    super();
  }
  created() {

    //PICKUP HASH OR SOMETHING FROM URL
    //to validate reset link and update password
    //this.$route.query["username"];


    this.user.meta = this.$route.query["m"];
    if(this.user.username){
      //this.emailFormSubmitted = true; 
      //this.forgotSubmit()
      //return
    }
    setTimeout(()=>{
      (this.$refs["_password"] as HTMLElement).focus()
    })
     window.scrollTo(0,0);
  }
  login(){
    router.push({ path: "login"});
  }
  stengthPass() {
    let value = this.user.password;
    console.log("Check pass strength :", value);
    if (this.strongRegex.test(value)) {
      this.passwordStrength["background-color"] = "green";
    } else if (this.mediumRegex.test(value)) {
      this.passwordStrength["background-color"] = "orange";
    } else {
      this.passwordStrength["background-color"] = "red";
    }
    this.checkMismatch();
  }
  checkMismatch() {
    if (this.user.password && this.user.repeat_password) {
      if (this.user.repeat_password != this.user.password) {
        this.mismatchPass = true;
      } else {
        this.mismatchPass = false;
      }
    } else {
    }
    console.log("checkMismatch", this.mismatchPass);
  }
  async updatePassword() {
    console.log("this.user",JSON.stringify(this.user))
    return
    this.errorMessage = "";
    this.processing = true;
    let result;
    try {
      console.log("running api call");
      result = await axios.post(`${this.authAPIUrl}reset-password`, {
        password: this.user.password, repeat_password:this.user.repeat_password, meta:this.user.meta
      });
    } catch (e) {
      console.log("Error while resetting password", e);
      this.processing = false;
      this.errorMessage =
        "Error connecting to the server. Please check your internet connection and try again";
      return;
    }
    if (result.data) {
      let data = result.data;
      console.log("user", data, data["error"], data["success"]);
      if (data["error"]) {
        console.log("Error in resetting password");
        this.errorMessage = "Error while processing your request. Please try again";
        this.processing = false;
        return;
      }
      else if(data["success"]){
        console.log("success!")
        this.processing = false;
        this.emailFormSubmitted = true
      }
      else{
        console.log("else catch all")
        this.processing = false;
        this.emailFormSubmitted = true
      }
    } else {
      console.log("Error in validating username. No data");
      this.processing = false;
    }
  }

}
